import React, { Fragment, useState } from 'react'
import { compact } from 'lodash'
import Table from 'UI/Table'
import { clusterColumns, clusterChartColumns, spuColumns, spuChartColumns, volumeColumns, volumeChartColumns } from './Columns'
import { TrendsChart } from 'Components/Chart'
import { Tabs, Tab } from 'react-bootstrap'

const NebulonCapacityReport = ({ clusters, trends_npod, trends_spu, trends_volume }) => {
  return (
    <Fragment>
      <Table
        {...{
          data: clusters,
          columns: compact(clusterColumns),
          SubComponent: ({ original: cluster }) => (
            <Table
              {...{
                columns: compact(spuColumns),
                data: cluster.spu_assets,
                showPagination: false,
                SubComponent: ({ original: spu }) => (
                  <Table
                    {...{
                      columns: compact(volumeColumns),
                      data: spu.volumes,
                      showPagination: false,
                    }}
                  />
                ),
              }}
            />
          ),
        }}
      />
      <Tabs id="cloudcore-nebulon-capacity-trend" className="mt-3">
        <Tab eventKey='Npod' title='Npod'>
          <TrendsChart trends={trends_npod} chartColumns={clusterChartColumns} />
        </Tab>
        <Tab eventKey='Host' title='Host'>
          <TrendsChart trends={trends_spu} chartColumns={spuChartColumns} />
        </Tab>
        <Tab eventKey='Volume' title='Volume'>
          <TrendsChart trends={trends_volume} chartColumns={volumeChartColumns} />
        </Tab>
      </Tabs>
    </Fragment>
  );
}

export default NebulonCapacityReport
